import { QueryDtoOf } from '@40seas/entities/common';
import { FinancialConnection } from '@40seas/entities/financial-connections';

export class FinancialConnectionQueryDto extends QueryDtoOf(FinancialConnection) {}
